<template>
    <div class="left-main">
        <ul>
            <template v-for="item in template">
                <li :key="item.id" :class="{'li-activ': templateInfo.id === item.id}">
                    <p class="li-name" @click="changeItem(item)">{{item.name}}</p>
                    <div class="li-icon">
                        <p @click="bindEdit(item)"><i class="el-icon-edit"></i></p>
                        <p @click="bindDel(item)"><i class="el-icon-close"></i></p>
                    </div>
                </li>
            </template>
        </ul>
        <!-- 修改/添加模板 -->
        <add-template ref="addTemplate" :title="2"></add-template>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import AddTemplate from './addTemplate'
import { deleteTemplateInfo } from '@/api/dataCenter'

export default {
    props: {
        rightIndex: {
            type: Number,
            default: 0
        }
    },
    components: { AddTemplate },
    data() {
        return {
           loading: false
        }
    },
    computed:{
        ...mapGetters(["template", "templateInfo", "isAdd"])
    },
    methods: {
        ...mapMutations(["SET_TEMPLATE_INDICATORS", "SET_IS_ADD", "SET_TABLE_DATA"]),
        ...mapActions(["GetTemplate", "GetTemplateInfo", "GetTargetTable"]),
        // 修改模板
        bindEdit(item) {
            let form = {
                id: item.id,
                name: item.name
            }
            this.$refs.addTemplate.deal(form)
        },
        // 删除模板
        bindDel(item) {
            this.$confirm(`确定删除${item.name}?`, '提示', {
                showClose: false,
                showCancelButton: true,
                confirmButtonClass: 'data-center--confirm',
                type: 'warning'
            }).then(() => {
                deleteTemplateInfo({
                    id: item.id
                }).then(res => {
                    this.GetTemplate().then(res => {
                        if (item.id === this.templateInfo.id) {
                            // 删除选中
                            this.GetTemplateInfo(this.templateInfo)
                            if (this.isAdd) {
                                this.SET_IS_ADD(false)
                                this.SET_TEMPLATE_INDICATORS([])
                            }
                        }
                    })
                })
            }).catch( () => {
                this.loading = false
            })
        },
        // 选择模板
        changeItem(item) {
            if(item.id === this.templateInfo.id) return
            // 获取详情
            this.GetTemplateInfo(item)
            // 清除指标数据
            if (this.isAdd) {
                this.SET_IS_ADD(false)
                this.SET_TEMPLATE_INDICATORS([])
            }
            // 清除所选指标
            this.SET_TABLE_DATA([])
        }
    }
}
</script>

<style lang="less" scoped>
.left-main {
    overflow-y: overlay;
    color: #606266;
    ul {
        li {
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            padding: 0 10px;
            .li-name {
                width: 76%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .li-icon {
                width: 22%;
                display: flex;
                p {
                    width: 50%;
                    text-align: center;
                    line-height: 30px;
                }
                p:hover i{
                    color: #D3131A;
                }
            }
        }
        li:hover {
            background: rgb(245, 247, 250);
        }
        .li-activ {
            background: rgb(245, 247, 250);
            .li-name {
                color: #D3131A;
            }
        }
    }
}
</style>